import $ from 'jquery';
import { isMobile } from './utils'
export const init = (vm) => {

	// ak界面js
	let flag = true
	$(function() {
		if ($(window).width() <= 600 || isMobile()) {
			const height = $(window).height()
			$('.banner').height(height)
		}
	})

	window.onscroll = function() {
		const scrolltop = $(this).scrollTop()
		const first = $('.banner').height()
		const section2 = $('.section2').height()
		let redline, whiteline, dattedline
		let linewidth = ''
		if (scrolltop >= first + section2 && flag) {
			flag = false
			if ($(window).width() > 600) {
				redline = $('.redline')
				whiteline = $('.whiteline')
				dattedline = $('.dattedline')
				linewidth = '237.5px'
			} else {
				redline = $('.redline-mobile')
				whiteline = $('.whiteline-mobile')
				dattedline = $('.dattedline-mobile')
				linewidth = '51.25%'
            }
			redline.animate(
				{
					opacity: 1
				},
				800,
				'linear',
				function() {
					whiteline.animate(
						{
							width: linewidth
						},
						1000,
						function() {
							dattedline.animate(
								{
									opacity: 1
								},
								800,
								function() {}
							)
						}
					)
				}
			)
		}
		if(scrolltop >= $('.section2').offset().top - 40 && scrolltop < $('.section3').offset().top - 40 || scrolltop >= $('.section4').offset().top - 350 && scrolltop < $('.section5').offset().top - 40  || scrolltop >= $('.section6').offset().top - 40 && scrolltop < $('.section7').offset().top - 40) {
			vm.setHeaderStyle({headerStyle: 'dark'})
		}else {
			vm.setHeaderStyle({headerStyle: 'light'})
		}
	}
}
